export default "__VITE_ASSET__DWuZejPz__"